import { SceneContainer } from '../components/scene/SceneContainer'
import { useCurrentWorkspace } from '../store/hooks'
import { Collaborators } from '../components/invitations/Collaborators'

const ManageTeamScreen = () => {
  const { workspace } = useCurrentWorkspace()

  if (!workspace) {
    return <div>No workspace selected</div>
  }

  return (
    <SceneContainer>
      <Collaborators />
    </SceneContainer>
  )
}

export default ManageTeamScreen
